export default __webpack_public_path__ + "fe1aeb2dfca6e797436f70ac5256437b.svg";